/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

export const columns: TableColumn[] = [
    {
        Header: "tableCommon.sl_no",
        accessor: "slno",
    },
    {
        Header: "tableCommon.batch_code",
        accessor: "batch_number",
    },
    {
        Header: "plateInventory.tableColumns.batch_grn",
        accessor: "batch_grn",
    },
    {
        Header: "plateInventory.tableColumns.manufacture_details",
        accessor: "manufacturer_details",
    },
    {
        Header: "plateInventory.tableColumns.createdDate",
        accessor: "manufacturing_date",
    },
    {
        Header: "plateInventory.tableColumns.expiryDate",
        accessor: "expiry_date",
    },
    {
        Header: "plateInventory.quantity",
        accessor: "quantity",
    },
    {
        Header: "plateInventory.tableColumns.tube_type",
        accessor: "plate_type",
    },
    // {
    //     Header: "plateInventory.tableColumns.mediaType",
    //     accessor: "media_type_name",
    // },
    {
        Header: "plateInventory.tableColumns.qaStatus",
        accessor: "qa_status",
    },
    {
        Header: "plateInventory.tableColumns.status",
        accessor: "status",
    },
  ];


export const columnsByBatch: TableColumn[] = [
    {
        Header: "tableCommon.sl_no",
        accessor: "slno",
    },
    {
        Header: "plateInventory.tableColumns.batch_code",
        accessor: "batch_no",
    },
    {
        Header: "plateInventory.tableColumns.lotCode",
        accessor: "lot_code",
    },
    {
        Header: "plateInventory.tableColumns.quantity",
        accessor: "plate_count",
    },
    {
        Header: "plateInventory.tableColumns.visualInspectionStatus",
        accessor: "inspection_status",
    },
  ];


export const columnsByLotBatch: TableColumn[] = [
    {
        Header: "tableCommon.sl_no",
        accessor: "slno",
    },
    {
        Header: "plateInventory.tableColumns.batch_code",
        accessor: "batch_no",
    },
    {
        Header: "plateInventory.tableColumns.lotCode",
        accessor: "lot_code",
    },
    {
        Header: "tableCommon.seriel_number",
        accessor: "serial_number",
    },
    {
        Header: "plateInventory.tableColumns.manufacture_date",
        accessor: "manufacturing_date",
    },
    {
        Header: "plateInventory.tableColumns.expiry_date",
        accessor: "expiry_date",
    }, 
    {
        Header: "plateInventory.tableColumns.status",
        accessor: "status",
    },
  ];


export const discardColumns: TableColumn[] = [
    {
        Header: "tableCommon.sl_no",
        accessor: "slno",
    },
    {
        Header: "tableCommon.batch_code",
        accessor: "batch_id",
    },
    {
        Header: "plateInventory.tableColumns.manufacture_date",
        accessor: "manufacturingDate",
    },
    // {
    //     Header: "plateInventory.tableColumns.expiry_date",
    //     accessor: "expiry_date",
    // },
    {
        Header: "plateInventory.tableColumns.quantity",
        accessor: "quantity",
    },
    // {
    //     Header: "plateInventory.tableColumns.status",
    //     accessor: "status",
    // },
]

  
  interface TableColumn {
    Header: string;
    accessor: string;
  }
